<script setup lang="ts">
import { useCloseAccountModal } from '@/composables/useCloseAccountModal'

const { openCloseAccountModal } = useCloseAccountModal()
</script>

<template>
  <footer class="sa-account-close-footer">
    <button
      type="button"
      class="sa-btn-secondary sa-btn-close-account"
      @click="openCloseAccountModal"
    >
      {{ $t('Dashboard.Account.CloseAccount.Cta') }}
    </button>
  </footer>
</template>
